import { type Language } from './config';

const LANGUAGE_STORAGE_KEY = 'i18nextLng';

/**
 * Change the application language and refresh the page
 * This ensures all components and utilities pick up the new language
 */
export const changeLanguageWithRefresh = (language: Language): void => {
  // Store the new language in localStorage
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  
  // Refresh the page to ensure all components pick up the new language
  window.location.reload();
};

/**
 * Get the current language from localStorage
 * Falls back to 'en' if no language is set
 */
export const getCurrentLanguage = (): Language => {
  return (localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language) || 'en';
};
